import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";

const EmergencyFeedbackModal = ({ show, onClose, onSave }) => {

  const [localState, setLocalState] = useState({
    service_call_frequency: "",
    feedback: ""
  });

  useEffect(() => {
    if (show) {
      setLocalState({
        service_call_frequency: "",
        feedback: ""
      });
    }
  }, [show]);

  const handleSave = () => {

    if (!localState.service_call_frequency || !localState.feedback) {
      alert("Please fill all fields");
      return;
    }

    onSave(localState);
  };

  return (
    <Modal show={show} onHide={onClose} centered>

      <Modal.Header closeButton>
        <Modal.Title>Add Emergency Feedback</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>

          <Form.Group className="mb-3">
            <Form.Label>Service Call Frequency (Days)</Form.Label>
            <Form.Control
              type="number"
              placeholder="Enter number of days"
              value={localState.service_call_frequency}
              onChange={(e) =>
                setLocalState({
                  ...localState,
                  service_call_frequency: e.target.value
                })
              }
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Feedback</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              placeholder="Enter feedback"
              value={localState.feedback}
              onChange={(e) =>
                setLocalState({
                  ...localState,
                  feedback: e.target.value
                })
              }
            />
          </Form.Group>

        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>

        <Button variant="primary" onClick={handleSave}>
          Save
        </Button>
      </Modal.Footer>

    </Modal>
  );
};

export default EmergencyFeedbackModal;